var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabletUserIcon = function SvgTabletUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M28 12.131h-3.067l.267-.267a1.29 1.29 0 0 0 0-1.866 1.29 1.29 0 0 0-1.867 0L20.8 12.53c-.23.23-.4.597-.4.933 0 .371.141.675.4.934l2.533 2.533c.267.267.667.4.934.4.266 0 .666-.133.933-.4a1.29 1.29 0 0 0 0-1.867l-.267-.266H28c.8 0 1.333-.534 1.333-1.334S28.8 12.131 28 12.131M13.333 15.734c2.934 0 5.334-2.4 5.334-5.334 0-3.066-2.4-5.466-5.334-5.466S8 7.334 8 10.4c0 2.934 2.4 5.334 5.333 5.334M20.4 19.336c-1.867-.666-4.267-.933-7.067-1.066-2.8 0-5.333.266-7.066 1.066-.934.4-1.6.934-2.134 1.6-.533.667-.8 1.6-.8 2.534s.4 1.866 1.067 2.533S6 27.07 7.067 27.07H19.6c1.067 0 2-.4 2.667-1.067a3.64 3.64 0 0 0 1.066-2.533c0-.934-.266-1.867-.8-2.534-.533-.666-1.333-1.2-2.133-1.6",
    clipRule: "evenodd"
  })));
};
export default SvgTabletUserIcon;